import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ReviewRepliesPage } from '@/features/marketing/reviews/replies/review-replies-page';

type ReviewRepliesSearch = { show?: 'replied' };

/**
 * Marketing › Reviews › Reply to reviews. A sibling of the Reviews overview route (not nested: the overview
 * renders no outlet); the nav still highlights Reviews by URL segment. The low-review email links here.
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/reviews_/replies')({
  // Only the Replied history lives in the URL (`?show=replied`); the queue is the default. `?show=posted` (the
  // tab's old name — bookmarks, older links) still opens Replied.
  validateSearch: (search: Record<string, unknown>): ReviewRepliesSearch => ({
    show: search.show === 'replied' || search.show === 'posted' ? 'replied' : undefined,
  }),
  component: ReviewRepliesRoute,
});

function ReviewRepliesRoute() {
  const { orgId } = Route.useParams();
  const { show } = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/reviews/replies' });

  return (
    <ReviewRepliesPage
      routeOrgId={orgId}
      view={show === 'replied' ? 'replied' : 'queue'}
      onSelectView={(view) => navigate({ search: { show: view === 'replied' ? 'replied' : undefined } })}
    />
  );
}
